import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { parentMessages$, publishParentMessage } from '../security/EmbedMessageBus';
import { ISDKPlaylistInfo, ISDKPlaylistSwitch } from './ISDKPlaylistContracts';

@Injectable({
	providedIn: 'root'
})
export class EmbedPlaylistService {

	private formatPlaylistLoadedInfo(playlist: any): ISDKPlaylistInfo {
		return {
			id: playlist.id,
			name: playlist.name,
			videos: playlist.videos?.map(video => {
				return {
					id: video.id,
					title: video.title,
					ownerProfileImageUri: video.ownerProfileImageUri,
					ownerFullName: video.ownerFullName,
				};
			}) ?? []
		};
	}

	public onPlaylistLoaded(playlist: any) {
		publishParentMessage('playlistLoaded', this.formatPlaylistLoadedInfo(playlist));
	}

	public getSwitchVideo(playlist: any): Observable<ISDKPlaylistSwitch> {
		// ignore request for video that isn't in the playlist
		function checkInPlaylist(msg?: ISDKPlaylistSwitch | undefined): msg is ISDKPlaylistSwitch {
			return !msg?.videoId || playlist.videos?.some(({ id }) => id === msg?.videoId);
		}

		return parentMessages$.pipe(
			filter((e => e.event === 'switchVideo' && checkInPlaylist(e.msg))),
			map(e => e.msg)
		);
	}
}
